import axios from '../../service/index'
import React, { Component } from 'react'
import { Button, Divider, Table } from 'antd'


class WxChannelsDetail extends Component {
  state = {
    columns: [{
      title: '用户昵称',
      dataIndex: 'userName',
      align: 'center',
      key: 'userName',
    },
    {
      title: '手机号',
      dataIndex: 'phone',
      align: 'center',
      key: 'phone',
     
    },{
      title: '观看次数',
      dataIndex: 'viewersNum',
      align: 'center',
      key: 'viewersNum',
    },{
      title: '咨询师',
      dataIndex: 'zsKefuName',
      align: 'center',
      key: 'zsKefuName',
    },{
      title: '注册时间',
      dataIndex: 'userRegisterTime',
      align: 'center',
      key: 'userRegisterTime',
    },],
    dataSource: [],
    total: 0,
    current: 1,
    size: 10,
    id:'',
    name: '',
    type: '' // type类型
  }
  pageChange = (current) => {
    this.setState({current: current})
  }
  sizeChange = (current, size) => {
    this.setState({size: size})
  }
  viewingDetails() {
    let {id} = this.props.location.state
    axios.post('/wxChannels/viewingDetails',{liveId: id}).then(res => {
      if (res.data.code === '200') {
        this.setState({dataSource: res.data.data.records})
      }
    })
  }
  componentDidMount() {
    let {id, name,type} = this.props.location.state
    this.setState({id,  name, type},() => {
      this.viewingDetails()
    })
  }
  exportData() {
		let id = this.state.id;	
		axios.get(`/wxChannels/exportUserGet?liveId=${id}`, { responseType: 'blob' }).then(res => {
			const link = document.createElement('a')
			let blob = new Blob([res.data], { type: 'application/vnd.ms-excel' })
			link.style.display = 'none'
			link.href = URL.createObjectURL(blob)
			link.setAttribute('download', '直播用户数据.xlsx')
			document.body.appendChild(link)
			link.click()
			document.body.removeChild(link)
		})
	}
  render() {
    let {dataSource, columns,name} = this.state
    return (
      <div>
        <div style={{ display: 'flex', justifyContent: 'space-between'}}>
					<span style={{ display: 'flex', alignItems: 'center', fontSize: '18px', fontWeight: '600' }}>{name}</span>
					<span className="my-button-txt" onClick={() => {
						this.props.history.push('/statistics',{type: this.state.type})
					}}>返回上一级</span>
				</div>
        <Divider />
        <div style={{ display: 'flex', justifyContent: 'end',marginBottom: '10px' }}>
							<Button className='my-button-primary' style={{ marginLeft: '20px'}} type='primary' onClick={() => {
								this.exportData()
							}}>导出</Button>
						</div>
				
        <div>
        <Table dataSource={dataSource} columns={columns} rowKey={record => record.subjectId} pagination={false} />
        </div>
      </div>
    )
  }
}
export default WxChannelsDetail